import ReactDOM from 'react-dom';
import './ConfirmDialog.css';

/**
 * Diálogo de confirmación con estilo ALINEA (sustituye window.confirm).
 */
export default function ConfirmDialog({
    open,
    title = '¿Confirmar?',
    message,
    detail,
    confirmLabel = 'Confirmar',
    cancelLabel = 'Cancelar',
    tone = 'primary',
    busy = false,
    onConfirm,
    onCancel,
}) {
    if (!open) return null;

    const panel = (
        <div
            className="confirm-dialog-backdrop"
            role="presentation"
            onClick={(e) => {
                if (e.target === e.currentTarget && !busy) onCancel?.();
            }}
        >
            <div
                className="glass-card confirm-dialog-panel"
                role="alertdialog"
                aria-modal="true"
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-desc"
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    className={`confirm-dialog-icon${tone === 'warning' ? ' confirm-dialog-icon--warning' : ''}`}
                    aria-hidden
                >
                    {tone === 'warning' ? '⚠️' : '✓'}
                </div>
                <h2 id="confirm-dialog-title" className="confirm-dialog-title">
                    {title}
                </h2>
                <p id="confirm-dialog-desc" className="confirm-dialog-message">
                    {message}
                </p>
                {detail ? <p className="confirm-dialog-detail">{detail}</p> : null}
                <div className="confirm-dialog-actions">
                    <button type="button" className="btn btn-secondary" disabled={busy} onClick={onCancel}>
                        {cancelLabel}
                    </button>
                    <button type="button" className="btn btn-primary" disabled={busy} onClick={onConfirm}>
                        {busy ? 'Procesando…' : confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(panel, document.body);
}
